
<style>
.flexHeaderRight {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
}

.flexLinks {
    display: flex;
    align-items: center;
}
</style>
<template>
    <header id="headerApp" class="js-page-header fixed top-0 z-50 w-full bg-white dark:bg-jacarta-900 border-b border-gray-100 dark:border-jacarta-800 transition-colors">
        <div class="flexHeaderRight items-center px-4 py-2 xl:px-8 max-w-7xl mx-auto">

            <NuxtLink to="/" class="shrink-0  ">
                <img loading="lazy" src='~/assets/logo_dark1.png' class="block max-h-9 dark:hidden" alt="Ticket Smile" />
                <img loading="lazy" src='~/assets/logo_white.png' class="hidden max-h-9 dark:block" alt="Ticket Smile" />
            </NuxtLink>
            <div class="  flexLinks">
                <SearchComponent />
                <!--      <div class="ml-auto">
                    <button
                        class="dropdown-toggle flex w-full items-center justify-between space-x-2 rounded-xl px-5 py-2 transition-colors hover:bg-jacarta-50 dark:text-white  hover:hover:text-pink-600 focus:text-pink-600   dark:hover:bg-jacarta-600"
                        data-bs-toggle="dropdown" id="languageSelect" aria-expanded="false">
                        <div class="flex items-center space-x-2">
                            <GlobeAmericasIcon class="h-5 w-5 " aria-hidden="true" />

                            <span class="mt-1 font-display text-sm ">Qualquer lugar</span>
                        </div>
                        <ChevronDownIcon class="h-4 w-4 " aria-hidden="true" />
                    </button>
                </div> -->
                <div
                    class="js-mobile-menu invisible lg:visible fixed inset-0 z-10 ml-auto items-center bg-white opacity-0 dark:bg-jacarta-800 lg:relative lg:inset-auto lg:flex lg:bg-transparent lg:opacity-100 dark:lg:bg-transparent">

                    <nav id="TsMenu" class="navbar menuTexto  pr-4">
                        <ul class="flex flex-col lg:flex-row ">
                            <li class="js-nav-dropdown group relative ">
                                <NuxtLink to="/" class="dropdown-toggle flex items-center justify-between py-3.5 font-display text-base
                                text-jacarta-700 hover:text-pink-600 focus:text-pink-600 dark:text-white dark:hover:text-pink-600
                                dark:focus:text-pink-600 lg:px-4" id="navDropdown-1" aria-expanded="false"
                                    role="button" data-bs-toggle="dropdown">Inicio

                                </NuxtLink>

                            </li>

                            <li class="js-nav-dropdown nav-item dropdown group relative ">
                                <NuxtLink to="/explorar" class="dropdown-toggle flex items-center justify-between py-3.5 font-display text-base
                                text-jacarta-700 hover:text-pink-600 focus:text-pink-600 dark:text-white dark:hover:text-pink-600
                                dark:focus:text-pink-600 lg:px-3" id="navDropdown-3" aria-expanded="false"
                                    role="button" data-bs-toggle="dropdown">Explorar
                                    <!-- <ChevronDownIcon class="ml-1 h-4 w-4 text-gray-300 hover:visible" aria-hidden="true" /> -->

                                </NuxtLink>
                           <!--      <ul class="dropdown-menu group-hover:visible lg:invisible -left-6 top-[85%] z-10 hidden grid-flow-col grid-rows-4 gap-x-4 whitespace-nowrap rounded-xl bg-white transition-all will-change-transform group-hover:opacity-100 dark:bg-jacarta-800 lg:absolute lg:!grid lg:translate-y-4 lg:py-8 lg:px-5 lg:opacity-0 lg:shadow-2xl lg:group-hover:translate-y-2"
                                    aria-labelledby="navDropdown-1">
                                    <li>
                                        <NuxtLink to="/explorar"
                                            class="flex items-center rounded-xl px-5 py-2 transition-colors
                                        hover:bg-jacarta-50 hover:text-pink-600 focus:text-pink-600 dark:hover:bg-jacarta-600">
                                            <span class="mr-3 rounded-xl bg-light-base p-[0.375rem]">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24"
                                                    height="24" class="h-4 w-4 fill-jacarta-700">
                                                    <path fill="none" d="M0 0h24v24H0z" />
                                                    <path
                                                        d="M22 12.999V20a1 1 0 0 1-1 1h-8v-8.001h9zm-11 0V21H3a1 1 0 0 1-1-1v-7.001h9zM11 3v7.999H2V4a1 1 0 0 1 1-1h8zm10 0a1 1 0 0 1 1 1v6.999h-9V3h8z" />
                                                </svg>
                                            </span>
                                            <span class="font-display text-sm text-jacarta-700 dark:text-white">Todas as
                                                Categorias </span>
                                        </NuxtLink>
                                    </li>
                                    <li>
                                        <NuxtLink to="/"
                                            class="flex items-center rounded-xl px-5 py-2 transition-colors
                                        hover:bg-jacarta-50 hover:text-pink-600 focus:text-pink-600 dark:hover:bg-jacarta-600">
                                            <span class="mr-3 rounded-xl bg-[#E4FCF4] p-[0.375rem]">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24"
                                                    height="24" class="h-4 w-4 fill-[#10B981]">
                                                    <path fill="none" d="M0 0h24v24H0z" />
                                                    <path
                                                        d="M12 2c5.522 0 10 3.978 10 8.889a5.558 5.558 0 0 1-5.556 5.555h-1.966c-.922 0-1.667.745-1.667 1.667 0 .422.167.811.422 1.1.267.3.434.689.434 1.122C13.667 21.256 12.9 22 12 22 6.478 22 2 17.522 2 12S6.478 2 12 2zm-1.189 16.111a3.664 3.664 0 0 1 3.667-3.667h1.966A3.558 3.558 0 0 0 20 10.89C20 7.139 16.468 4 12 4a8 8 0 0 0-.676 15.972 3.648 3.648 0 0 1-.513-1.86zM7.5 12a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm9 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zM12 9a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
                                                </svg>
                                            </span>
                                            <span class="font-display text-sm text-jacarta-700 dark:text-white">Arte</span>
                                        </NuxtLink>
                                    </li>
                                    <li>
                                        <NuxtLink to="/"
                                            class="flex items-center rounded-xl px-5 py-2 transition-colors
                                        hover:bg-jacarta-50 hover:text-pink-600 focus:text-pink-600 dark:hover:bg-jacarta-600">
                                            <span class="mr-3 rounded-xl bg-[#FDF7EE] p-[0.375rem]">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24"
                                                    height="24" class="h-4 w-4 fill-[#FEB240]">
                                                    <path fill="none" d="M0 0h24v24H0z" />
                                                    <path
                                                        d="M17.5 2a4.5 4.5 0 0 1 2.951 7.897c.355.967.549 2.013.549 3.103A9 9 0 1 1 3.55 9.897a4.5 4.5 0 1 1 6.791-5.744 9.05 9.05 0 0 1 3.32 0A4.494 4.494 0 0 1 17.5 2zm0 2c-.823 0-1.575.4-2.038 1.052l-.095.144-.718 1.176-1.355-.253a7.05 7.05 0 0 0-2.267-.052l-.316.052-1.356.255-.72-1.176A2.5 2.5 0 1 0 4.73 8.265l.131.123 1.041.904-.475 1.295A7 7 0 1 0 19 13c0-.716-.107-1.416-.314-2.083l-.112-.33-.475-1.295 1.04-.904A2.5 2.5 0 0 0 17.5 4zM10 13a2 2 0 1 0 4 0h2a4 4 0 1 1-8 0h2z" />
                                                </svg>
                                            </span>
                                            <span
                                                class="font-display text-sm text-jacarta-700 dark:text-white">Teatro</span>
                                        </NuxtLink>
                                    </li>

                                    <li>
                                        <NuxtLink to="/"
                                            class="flex items-center rounded-xl px-5 py-2 transition-colors
                                        hover:bg-jacarta-50 hover:text-pink-600 focus:text-pink-600 dark:hover:bg-jacarta-600">
                                            <span class="mr-3 rounded-xl bg-[#FFEEFA] p-[0.375rem]">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24"
                                                    height="24" class="h-4 w-4 fill-[#F35BC7]">
                                                    <path fill="none" d="M0 0h24v24H0z" />
                                                    <path d="M12 13.535V3h8v3h-6v11a4 4 0 1 1-2-3.465z" />
                                                </svg>
                                            </span>
                                            <span
                                                class="font-display text-sm text-jacarta-700 dark:text-white">Eletronica</span>
                                        </NuxtLink>
                                    </li>
                                    <li>
                                        <NuxtLink to="/"
                                            class="flex items-center rounded-xl px-5 py-2 transition-colors
                                        hover:bg-jacarta-50 hover:text-pink-600 focus:text-pink-600 dark:hover:bg-jacarta-600">
                                            <span class="mr-3 rounded-xl bg-[#EAF2FE] p-[0.375rem]">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24"
                                                    height="24" class="h-4 w-4 fill-[#428AF8]">
                                                    <path fill="none" d="M0 0h24v24H0z" />
                                                    <path
                                                        d="M2 6c0-.552.455-1 .992-1h18.016c.548 0 .992.445.992 1v14c0 .552-.455 1-.992 1H2.992A.994.994 0 0 1 2 20V6zm2 1v12h16V7H4zm10 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 2a5 5 0 1 1 0-10 5 5 0 0 1 0 10zM4 2h6v2H4V2z" />
                                                </svg>
                                            </span>
                                            <span
                                                class="font-display text-sm text-jacarta-700 dark:text-white">Viagens</span>
                                        </NuxtLink>
                                    </li>
                                    <li>
                                        <NuxtLink to="/"
                                            class="flex items-center rounded-xl px-5 py-2 transition-colors
                                        hover:bg-jacarta-50 hover:text-pink-600 focus:text-pink-600 dark:hover:bg-jacarta-600">
                                            <span class="mr-3 rounded-xl bg-[#EBEDFF] p-[0.375rem]">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24"
                                                    height="24" class="h-4 w-4 fill-[#737EF2]">
                                                    <path fill="none" d="M0 0h24v24H0z" />
                                                    <path
                                                        d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm.366 11.366l-3.469 6.01a8.053 8.053 0 0 0 4.459.51 9.937 9.937 0 0 1 .784-5.494l-1.774-1.026zm3.518 2.031a7.956 7.956 0 0 0-.587 3.894 8.022 8.022 0 0 0 3.077-2.456l-2.49-1.438zm-7.025-4.055a9.95 9.95 0 0 1-4.365 3.428 8.01 8.01 0 0 0 2.671 3.604l3.469-6.008-1.775-1.024zm11.103-.13l-.258.12a7.947 7.947 0 0 0-2.82 2.333l2.492 1.439a7.975 7.975 0 0 0 .586-3.893zM4 12c0 .266.013.53.038.789a7.95 7.95 0 0 0 3.078-2.454L4.624 8.897A7.975 7.975 0 0 0 4 12zm12.835-6.374l-3.469 6.008 1.775 1.025a9.95 9.95 0 0 1 4.366-3.43 8.015 8.015 0 0 0-2.419-3.402l-.253-.201zM12 4c-.463 0-.916.04-1.357.115a9.928 9.928 0 0 1-.784 5.494l1.775 1.025 3.469-6.01A7.975 7.975 0 0 0 12 4zm-3.297.71l-.191.088a8.033 8.033 0 0 0-2.886 2.367l2.49 1.438a7.956 7.956 0 0 0 .587-3.893z" />
                                                </svg>
                                            </span>
                                            <span
                                                class="font-display text-sm text-jacarta-700 dark:text-white">Esportes</span>
                                        </NuxtLink>
                                    </li>
                                    <li>
                                        <NuxtLink to="/"
                                            class="flex items-center rounded-xl px-5 py-2 transition-colors
                                        hover:bg-jacarta-50 hover:text-pink-600 focus:text-pink-600 dark:hover:bg-jacarta-600">
                                            <span class="mr-3 rounded-xl bg-[#F5FFED] p-[0.375rem]">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24"
                                                    height="24" class="h-4 w-4 fill-[#8DD059]">
                                                    <path fill="none" d="M0 0h24v24H0z" />
                                                    <path
                                                        d="M2 3.993A1 1 0 0 1 2.992 3h18.016c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V3.993zM4 5v14h16V5H4zm2 2h6v6H6V7zm2 2v2h2V9H8zm-2 6h12v2H6v-2zm8-8h4v2h-4V7zm0 4h4v2h-4v-2z" />
                                                </svg>
                                            </span>
                                            <span
                                                class="font-display text-sm text-jacarta-700 dark:text-white">Renomados</span>
                                        </NuxtLink>
                                    </li>
                                    <li>
                                        <NuxtLink to="/"
                                            class="flex items-center rounded-xl px-5 py-2 transition-colors
                                        hover:bg-jacarta-50 hover:text-pink-600 focus:text-pink-600 dark:hover:bg-jacarta-600">
                                            <span class="mr-3 rounded-xl bg-[#FFEEEE] p-[0.375rem]">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24"
                                                    height="24" class="h-4 w-4 fill-[#EF3D3D]">
                                                    <path fill="none" d="M0 0h24v24H0z" />
                                                    <path
                                                        d="M22 7h1v10h-1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v3zm-2 10h-6a5 5 0 0 1 0-10h6V5H4v14h16v-2zm1-2V9h-7a3 3 0 0 0 0 6h7zm-7-4h3v2h-3v-2z" />
                                                </svg>
                                            </span>
                                            <span class="font-display text-sm text-jacarta-700 dark:text-white">Baixo
                                                custo</span>
                                        </NuxtLink>
                                    </li>

                                </ul> -->
                            </li>
                            <li class="js-nav-dropdown group relative hidden">
                                <NuxtLink to="/" class="dropdown-toggle flex items-center justify-between py-3.5 font-display text-base
                                text-jacarta-700 hover:text-pink-600 focus:text-pink-600 dark:text-white dark:hover:text-pink-600
                                dark:focus:text-pink-600 lg:px-3" id="navDropdown-4" aria-expanded="false"
                                    role="button" data-bs-toggle="dropdown">Soluções


                                    <ChevronDownIcon class="h-4 w-4 text-gray-300 hover:visible" aria-hidden="true" />

                                </NuxtLink>
                                <ul class="dropdown-menu group-hover:visible lg:invisible left-0 top-[85%] z-50 hidden min-w-[200px] gap-x-4 whitespace-nowrap rounded-xl bg-white transition-all will-change-transform group-hover:opacity-100 dark:bg-jacarta-800 lg:absolute lg:grid lg:translate-y-4 lg:py-4 lg:px-2 lg:opacity-0 lg:shadow-2xl lg:group-hover:translate-y-2"
                                    aria-labelledby="navDropdown-4">
                                    <li>
                                        <NuxtLink to="/"
                                            class="flex items-center rounded-xl px-5 py-2 transition-colors
                                        hover:bg-jacarta-50 hover:text-pink-600 focus:text-pink-600 dark:hover:bg-jacarta-600">
                                            <span
                                                class="font-display text-sm text-jacarta-700 dark:text-white">Aplicativos</span>
                                        </NuxtLink>
                                    </li>
                                    <li>
                                        <NuxtLink to="/"
                                            class="flex items-center rounded-xl px-5 py-2 transition-colors
                                        hover:bg-jacarta-50 hover:text-pink-600 focus:text-pink-600 dark:hover:bg-jacarta-600">
                                            <span class="font-display text-sm text-jacarta-700 dark:text-white">Ingressos
                                                Online</span>
                                        </NuxtLink>
                                    </li>
                                    <li>
                                        <NuxtLink to="/"
                                            class="flex items-center rounded-xl px-5 py-2 transition-colors
                                        hover:bg-jacarta-50 hover:text-pink-600 focus:text-pink-600 dark:hover:bg-jacarta-600">
                                            <span class="font-display text-sm text-jacarta-700 dark:text-white">Gestão de
                                                bares</span>
                                        </NuxtLink>
                                    </li>
                                    <li>
                                        <NuxtLink to="/"
                                            class="flex items-center rounded-xl px-5 py-2 transition-colors
                                        hover:bg-jacarta-50 hover:text-pink-600 focus:text-pink-600 dark:hover:bg-jacarta-600">
                                            <span class="font-display text-sm text-jacarta-700 dark:text-white">Gestão de
                                                Restaurante</span>
                                        </NuxtLink>
                                    </li>
                                    <li>
                                        <NuxtLink to="/"
                                            class="flex items-center rounded-xl px-5 py-2 transition-colors
                                        hover:bg-jacarta-50 hover:text-pink-600 focus:text-pink-600 dark:hover:bg-jacarta-600">
                                            <span
                                                class="font-display text-sm text-jacarta-700 dark:text-white">Maquininhas</span>
                                        </NuxtLink>
                                    </li>
                                    <li>
                                        <NuxtLink to="/"
                                            class="flex items-center rounded-xl px-5 py-2 transition-colors
                                        hover:bg-jacarta-50 hover:text-pink-600 focus:text-pink-600 dark:hover:bg-jacarta-600">
                                            <span class="font-display text-sm text-jacarta-700 dark:text-white">Totem
                                                PDV</span>
                                        </NuxtLink>
                                    </li>

                                    <li>
                                        <NuxtLink to="/"
                                            class="flex items-center rounded-xl px-5 py-2 transition-colors
                                        hover:bg-jacarta-50 hover:text-pink-600 focus:text-pink-600 dark:hover:bg-jacarta-600">
                                            <span
                                                class="font-display text-sm text-jacarta-700 dark:text-white mr-2">Produtos
                                                Fisicos</span>
                                            <span
                                                class="rounded bg-green-500 py-1 px-2 text-xxs font-bold uppercase leading-none text-white">new</span>
                                        </NuxtLink>
                                    </li>
                                    <li>
                                        <NuxtLink to="/"
                                            class="flex items-center rounded-xl px-5 py-2 transition-colors
                                        hover:bg-jacarta-50 hover:text-pink-600 focus:text-pink-600 dark:hover:bg-jacarta-600">
                                            <span class="font-display text-sm text-jacarta-700 dark:text-white mr-2">Smile
                                                Card/Band </span>
                                            <span
                                                class="rounded bg-green-500 py-1 px-2 text-xxs font-bold uppercase leading-none text-white">new</span>
                                        </NuxtLink>
                                    </li>
                                    <li>
                                        <NuxtLink to="/"
                                            class="flex items-center rounded-xl px-5 py-2 transition-colors
                                        hover:bg-jacarta-50 hover:text-pink-600 focus:text-pink-600 dark:hover:bg-jacarta-600">
                                            <span class="font-display text-sm text-jacarta-700 dark:text-white mr-2">Smile
                                                LInk</span>
                                            <span
                                                class="rounded bg-green-500 py-1 px-2 text-xxs font-bold uppercase leading-none text-white">new</span>
                                        </NuxtLink>
                                    </li>
                                </ul>
                            </li>

                        </ul>
                    </nav>

                    <div class="hidden lg:flex">



                        <NuxtLink to="/painel" target="_blank" class="flex items-center gap-1.5 px-4 py-2 mr-2 rounded-lg bg-pink-600 hover:bg-pink-700 text-white text-sm font-semibold transition-colors">
                            <SparklesIcon class="h-4 w-4" aria-hidden="true" />
                            <span>Criar Evento</span>
                        </NuxtLink>

                        <NuxtLink v-if="!hasMounted || !userData" to="/login" class="flex items-center gap-1.5 px-4 py-2 rounded-lg border border-gray-200 dark:border-jacarta-600 text-gray-700 dark:text-white text-sm font-semibold hover:border-pink-500 hover:text-pink-600 transition-colors bg-white dark:bg-jacarta-800">
                            <ArrowRightEndOnRectangleIcon class="h-4 w-4" aria-hidden="true" />
                            <span>Entrar</span>
                        </NuxtLink>
                        <div v-else class="js-nav-dropdown group-dropdown relative">
                            <button class="dropdown-toggle group flex items-center gap-1.5 px-4 py-2 rounded-lg border border-gray-200 dark:border-jacarta-600 bg-white dark:bg-jacarta-800 text-gray-700 dark:text-white text-sm font-semibold hover:border-pink-500 hover:text-pink-600 transition-colors" id="profileDropdown" aria-expanded="false" data-bs-toggle="dropdown" aria-label="profile">
                                <UserCircleIcon class="h-4 w-4" aria-hidden="true" />
                                <span>Minha conta</span>


                            </button>

                            <div class="dropdown-menu group-dropdown-hover:visible lg:invisible !-right-4 !top-[85%] !left-auto z-50 hidden min-w-[14rem] whitespace-nowrap rounded-xl bg-white transition-all will-change-transform before:absolute before:-top-3 before:h-3 before:w-full group-dropdown-hover:opacity-100 dark:bg-jacarta-800 lg:absolute lg:grid lg:!translate-y-4 lg:py-4 lg:px-2 lg:opacity-0 lg:shadow-2xl"
                                aria-labelledby="profileDropdown">


                                <button v-if="userData"
                                    class="js-copy-clipboard my-4 flex select-none items-center whitespace-nowrap px-5 font-display leading-none text-jacarta-700 dark:text-white"
                                    data-tippy-content="Copy">
                                    <span class="max-w-[10rem] overflow-hidden text-ellipsis capitalize">{{ displayName
                                    }}</span>

                                </button>

                                <!-- <div class="mx-5 mb-6 rounded-lg border border-jacarta-100 p-4 dark:border-jacarta-600">
                                    <span class="text-sm font-medium tracking-tight dark:text-jacarta-200">Saldo</span>
                                    <div class="flex items-center">
                                        <BanknotesIcon class="h-5 w-5 text-gray-300" aria-hidden="true" />

                                        <span class="text-lg font-bold text-green mr-1 ml-1">R$ 00,00</span>
                                        <ArrowTopRightOnSquareIcon class="h-5 w-5 text-gray-300" aria-hidden="true" />

                                    </div>
                                </div> -->
                                <NuxtLink to="/perfil" class="flex items-center space-x-2 rounded-xl px-5 py-2 transition-colors
                                hover:bg-jacarta-50 hover:text-pink-600 focus:text-pink-600 dark:hover:bg-jacarta-600">
                                    <UserCircleIcon class="h-5 w-5 text-gray-300" aria-hidden="true" />
                                    <span class="mt-1 font-display text-sm text-jacarta-700 dark:text-white">Meu
                                        Perfil</span>
                                </NuxtLink>
                                <NuxtLink to="/perfil/ingressos" class="flex items-center space-x-2 rounded-xl px-5 py-2 transition-colors
                                hover:bg-jacarta-50 hover:text-pink-600 focus:text-pink-600 dark:hover:bg-jacarta-600">
                                    <TicketIcon class="h-5 w-5 text-gray-300" aria-hidden="true" />

                                    <span class="mt-1 font-display text-sm text-jacarta-700 dark:text-white">Meus
                                        Ingressos</span>
                                </NuxtLink>
                                <div class="dropdown ">
                                    <button @click='openOrganizador = !openOrganizador' class="dropdown-toggle flex w-full items-center justify-between space-x-2 rounded-xl
                                    px-5 py-2 transition-colors hover:bg-jacarta-50 hover:text-pink-600 focus:text-pink-600
                                    dark:hover:bg-jacarta-600 "  :class="{ 'bg-jacarta-50 dark:bg-jacarta-600': openOrganizador }" data-bs-toggle="dropdown" id="languageSelect"
                                        aria-expanded="false">
                                        <div class="flex items-center space-x-2">
                                            <BuildingOffice2Icon class="h-5 w-5 text-gray-300" aria-hidden="true" />
                                            <span class="mt-1 font-display text-sm text-jacarta-700 dark:text-white">Area do
                                                Organizador</span>
                                        </div>
                                        <ChevronUpIcon id='arrowup' v-if="openOrganizador" class="h-5 w-5 text-gray-300 "
                                            aria-hidden="true" />
                                        <ChevronDownIcon id='arrowdown' v-else class="h-5 w-5 text-gray-300" aria-hidden="true" />



                                    </button>
                                    <div id='menuDropd' ref='menuDropd'
                                        class="dropdown-menu z-50  w-full min-w-[200px] whitespace-nowrap rounded-xl bg-white py-4 px-2 text-left shadow-xl dark:bg-jacarta-900"
                                        aria-labelledby="languageSelect" :class="{ 'hidden': !openOrganizador }">
                                        <NuxtLink to="/painel?r=1" target="_blank" class="hover:text-pink-600 dropdown-item flex items-center justify-between
                                        rounded-xl px-5 py-2 font-display text-sm font-semibold transition-colors
                                        hover:bg-jacarta-50 dark:text-pink-600 dark:hover:bg-jacarta-600">
                                            <div class="flex items-center space-x-2 ">
                                                <BuildingOffice2Icon class="h-5 w-5 text-gray-300" aria-hidden="true" />
                                                <span class="mt-1 font-display text-sm dark:text-white">Eventos</span>
                                                <ArrowTopRightOnSquareIcon class="h-3 w-3 text-gray-300"
                                                    aria-hidden="true" />
                                            </div>

                                        </NuxtLink>
                                       <!--  <NuxtLink to="/painel?r=2" target="_blank" class="hover:text-pink-600 dropdown-item flex items-center justify-between
                                        rounded-xl px-5 py-2 font-display text-sm font-semibold transition-colors
                                        hover:bg-jacarta-50 dark:text-pink-600 dark:hover:bg-jacarta-600">
                                            <div class="flex items-center space-x-2">
                                                <BuildingStorefrontIcon class="h-5 w-5 text-gray-300" aria-hidden="true" />
                                                <span
                                                    class="mt-1 font-display text-sm dark:text-white">Bares/Restaurante</span>
                                                <ArrowTopRightOnSquareIcon class="h-3 w-3 text-gray-300"
                                                    aria-hidden="true" />
                                            </div>
                                        </NuxtLink>
                                        <NuxtLink to="/painel?r=3" target="_blank" class="hover:text-pink-600 dropdown-item flex items-center
                                        justify-between rounded-xl px-5 py-2 font-display
                                        text-sm font-semibold transition-colors hover:bg-jacarta-50
                                        dark:text-pink-600 dark:hover:bg-jacarta-600">
                                            <div class="flex items-center space-x-2">
                                                <CreditCardIcon class="h-5 w-5 text-gray-300" aria-hidden="true" />
                                                <span class="mt-1 font-display text-sm dark:text-white">SmileCard</span>
                                                <ArrowTopRightOnSquareIcon class="h-3 w-3 text-gray-300"
                                                    aria-hidden="true" />
                                            </div>
                                        </NuxtLink>

                                        <NuxtLink to="/painel?r=4" target="_blank" class="hover:text-pink-600 dropdown-item flex items-center justify-between
                                        rounded-xl px-5 py-2 font-display text-sm font-semibold transition-colors
                                        hover:bg-jacarta-50 dark:text-pink-600 dark:hover:bg-jacarta-600">
                                            <div class="flex items-center space-x-2">
                                                <CursorArrowRippleIcon class="h-5 w-5 text-gray-300" aria-hidden="true" />
                                                <span class="mt-1 font-display text-sm dark:text-white">SmileLink</span>
                                                <ArrowTopRightOnSquareIcon class="h-3 w-3 text-gray-300"
                                                    aria-hidden="true" />

                                            </div>
                                        </NuxtLink> -->
                                    </div>
                                </div>
                                <NuxtLink to='/auth/sair' name='Logout' class="flex items-center space-x-2 rounded-xl px-5 py-2 transition-colors
                                hover:bg-jacarta-50 hover:text-pink-600 focus:text-pink-600 dark:hover:bg-jacarta-600">
                                    <ArrowRightStartOnRectangleIcon class="h-5 w-5 text-gray-300" aria-hidden="true" />
                                    <span class="mt-1 font-display text-sm text-jacarta-700 dark:text-white">Sair</span>
                                </NuxtLink>


                            </div>
                        </div>

                    </div>
                </div>

                <div class="ml-auto flex ">

                    <!-- Hamburger button for Profile Sidebar (Mobile Only) -->
                    <button v-if="isPerfilRoute" @click="isOpen = true" class="lg:hidden group ml-2 flex h-10 w-10 items-center justify-center rounded-full border border-jacarta-100 bg-white transition-colors hover:border-transparent hover:bg-pink-600 focus:border-transparent focus:bg-pink-600 dark:border-transparent dark:bg-white/[.15] dark:hover:bg-pink-600">
                        <i class="uil uil-bars text-lg text-jacarta-700 transition-colors group-hover:text-white dark:text-white"></i>
                    </button>

                    <!-- Theme Toggle (Hidden on mobile profile pages to save space for the hamburger) -->
                    <button v-show="!isPerfilRoute || false" @click="setTheme(!darkMode)" class="js-dark-mode-trigger group ml-2 flex h-10 w-10 items-center justify-center rounded-full border border-jacarta-100 bg-white transition-colors hover:border-transparent hover:bg-pink-600 focus:border-transparent focus:bg-pink-600 dark:border-transparent dark:bg-white/[.15] dark:hover:bg-pink-600 lg:flex" :class="{ 'hidden lg:flex': isPerfilRoute }">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"
                            class="dark-mode-light h-4 w-4 fill-jacarta-700 transition-colors group-hover:fill-white group-focus:fill-white dark:hidden">
                            <path fill="none" d="M0 0h24v24H0z" />
                            <path
                                d="M11.38 2.019a7.5 7.5 0 1 0 10.6 10.6C21.662 17.854 17.316 22 12.001 22 6.477 22 2 17.523 2 12c0-5.315 4.146-9.661 9.38-9.981z" />
                        </svg>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"
                            class="dark-mode-dark hidden h-4 w-4 fill-jacarta-700 transition-colors group-hover:fill-white group-focus:fill-white dark:block dark:fill-white">
                            <path fill="none" d="M0 0h24v24H0z" />
                            <path
                                d="M12 18a6 6 0 1 1 0-12 6 6 0 0 1 0 12zM11 1h2v3h-2V1zm0 19h2v3h-2v-3zM3.515 4.929l1.414-1.414L7.05 5.636 5.636 7.05 3.515 4.93zM16.95 18.364l1.414-1.414 2.121 2.121-1.414 1.414-2.121-2.121zm2.121-14.85l1.414 1.415-2.121 2.121-1.414-1.414 2.121-2.121zM5.636 16.95l1.414 1.414-2.121 2.121-1.414-1.414 2.121-2.121zM23 11v2h-3v-2h3zM4 11v2H1v-2h3z" />
                        </svg>
                    </button>


                </div>
            </div>
        </div>

    </header>
</template>

<script setup >
import { useState } from '#app'
import { onMounted, watch } from '@vue/runtime-core'
import { ChevronDownIcon, ArrowRightEndOnRectangleIcon, GlobeAmericasIcon, } from '@heroicons/vue/24/outline'
import { UserCircleIcon, CursorArrowRippleIcon, BanknotesIcon, TicketIcon, ArrowRightStartOnRectangleIcon, ArrowTopRightOnSquareIcon, ChevronUpIcon, BuildingOffice2Icon, BuildingStorefrontIcon, CreditCardIcon, SparklesIcon } from '@heroicons/vue/24/solid'
const nuxtApp = useNuxtApp();
const userDataStore = useUserDataStore()
const userData = computed(() => userDataStore.user)
const hasMounted = ref(false)
const displayName = computed(() => {
    const user = userData.value
    return user?.fullName || `${user?.firstName || ''} ${user?.lastName || ''}`.trim() || user?.email || 'Minha conta'
})

const openOrganizador = ref(false)
const darkMode = useCookie('theme')

const isOpen = useState('profileMenuOpen', () => false);
const route = useRoute();
const isPerfilRoute = computed(() => route.path.startsWith('/perfil'));

const setTheme = (newTheme) => {

    darkMode.value = newTheme
   // console.log('aqq1', darkMode.value)

    if (darkMode.value) {
        document.documentElement.classList.add('dark')
        document.documentElement.classList.remove('light')
    } else {
        document.documentElement.classList.add('light')
        document.documentElement.classList.remove('dark')
    }
}

onMounted(() => {
    hasMounted.value = true
})



nuxtApp.hook('page:finish', () => {
  const isDarkModePreferred = window.matchMedia('(prefers-color-scheme: dark)').matches


  if (darkMode.value ===  null) {
    darkMode.value = isDarkModePreferred
  }else if (darkMode.value) {
    document.documentElement.classList.add('dark')
    document.documentElement.classList.remove('light')
  } else {

    document.documentElement.classList.add('light')
    document.documentElement.classList.remove('dark')
  }
})

</script>

